import { render, staticRenderFns } from "./invoice_register_info.vue?vue&type=template&id=192ee27c&scoped=true"
import script from "./invoice_register_info.vue?vue&type=script&lang=js"
export * from "./invoice_register_info.vue?vue&type=script&lang=js"
import style0 from "./invoice_register_info.vue?vue&type=style&index=0&id=192ee27c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ee27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
